import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "../Modal";
import RightSidebarStyle from "./style";
import {AddHoliday,EditHoliday,DeleteHoliday,} from "../../Redux/Actions/HolidayAction";
import Close from "../../Assets/Close.svg";
import { connect } from "react-redux";
import moment from "moment/moment";
import { Switch, ConfigProvider, TimePicker, Space } from 'antd';
import dayjs from 'dayjs'

const {RangePicker} = TimePicker;
function RightSideBar(props) {
  const [response, setResponse] = useState(false);
  const [HolidayName, setHolidayName] = useState("");
  const [HolidayNameError, setHolidayNameError] = useState("");
  const [HolidayDate, setHolidayDate] = useState("");
  const [HolidayDateError, setHolidayDateError] = useState("");
  const [partialTimes, setPartialTimes] = useState([null,null]);
  const [OpenModal, setModal] = useState(false);
  const [IsPartialHoliday, setIsPartialHoliday] = useState(false);
  const [TimePickerError, setTimePickerError] = useState(false);

  useEffect(() => {
    if (props.data) {
      setHolidayName(props.data.name);
      setHolidayDate(props.data.date);
      if (props.data.start_time) {
        setPartialTimes([dayjs(props.data.start_time, 'HH:mm'), dayjs(props.data.end_time, 'HH:mm')]);
      }
      setTimePickerError(false);
      setIsPartialHoliday(Boolean(props.data.is_partial_holiday));
    }
  }, [props]);

  const CloseSidebar = (e) => {
    e.preventDefault();
    setHolidayName("");
    setHolidayDate("");
    setPartialTimes([null, null]);
    setIsPartialHoliday(false);
    props.close();
  };

  const handleModal = (e, type) => {
    e.preventDefault();
    if (type !== "delete") {
      setModal(type);
    } else {
      setHolidayDateError("");
      setModal(type);
    }
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const onSwitchChange = (checked) => {
    setIsPartialHoliday(checked);
  };

  const onCalendarChange = (value) => {
    if (value[0] === null && value[1] === null) { // clear button selected
      setPartialTimes([null, null]);
      console.log('Cleared');
      return;
    }
    console.log('Values', value);

    const startTime = value[0] ? dayjs(value[0]) : null;
    console.log('Start', startTime);
    const endTime = value[1] ? dayjs(value[1]) : null;
    console.log('End', endTime);
    setPartialTimes([startTime, endTime]);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "delete_yes") {
      props.DeleteHoliday(props.data.id);
    } else if (type === "delete_no") {
      setModal(false);
    } else if (type === "update_yes") {
      if (IsPartialHoliday) {
        const data = {
          name: HolidayName,
          date: HolidayDate,
          id: props.data.id,
          start_time: dayjs(partialTimes[0]).format('HH:mm'),
          end_time: dayjs(partialTimes[1]).format('HH:mm'),
          is_partial_holiday: 1
        };
        props.EditHoliday(data);
      } else {
        const data = {
          name: HolidayName,
          date: HolidayDate,
          id: props.data.id,
          start_time: null,
          end_time: null,
          is_partial_holiday: 0
        };
        props.EditHoliday(data);
      }
    } else if (type === "add_yes") {
      if (IsPartialHoliday) {
        const data = {
          name: HolidayName,
          date: HolidayDate,
          start_time: dayjs(partialTimes[0]).format('HH:mm'),
          end_time: dayjs(partialTimes[1]).format('HH:mm'),
          is_partial_holiday: 1
        };
        props.AddHoliday(data);
      } else {
        const data = {
          name: HolidayName,
          date: HolidayDate,
          start_time: null,
          end_time: null,
          is_partial_holiday: 0
        };
        props.AddHoliday(data);
      }
    } else if (type === "add_no") {
      setModal(false);
    } else {
      setModal(false);
    }
    if (type === "add_yes" || type === "update_yes" || type === "delete_yes") {
      setModal(false);
      setHolidayName("");
      setHolidayNameError("");
      setHolidayDate("");
      setHolidayDateError("");
      setPartialTimes([null, null]);
      setIsPartialHoliday(false);
      props.close();
    }
  };

  const handleHolidayName = (e) => {
    if (e.target.value.length < 161) {
      setHolidayName(e.target.value);
      setHolidayNameError("");
    } else {
      setHolidayNameError("name must be less than 160 characters");
    }
  };

  const handleHolidayDate = (date) => {
    setHolidayDate(date ? date.toISOString() : "");
  };

  useEffect(() => {
    props.edit_data &&
      response &&
      props.response({
        type: props.edit_data.status,
        message: props.edit_data.message,
      });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data &&
      response &&
      props.response({
        type: props.delete_data.status,
        message: props.delete_data.message,
      });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data &&
      response &&
      props.response({
        type: props.add_data.status,
        message: props.add_data.message,
      });
  }, [props.add_data]);

  return (
    <>
      {props && props.sidebar && (
        <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />
      )}
      <div
        className={
          props && props.sidebar
            ? "dark-background right-sidebar-wrap"
            : "dark-background right-sidebar-wrap right-sidebar-wrap-close"
        }
      >
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} Holiday</h5>
          <img
            onClick={(e) => CloseSidebar(e)}
            src={Close}
            alt="Close"
            className="cursor-pointer"
          />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm">
          <div className="mt-4">
          <label className="text-grey-6 f-16 d-block mb-1">
              Partial Holiday<span className="text-danger">*</span>
            </label>
            <Switch checked={IsPartialHoliday} 
                    onChange={onSwitchChange} 
                    style={{backgroundColor: IsPartialHoliday === true ? '#BDFF00' : 'grey'}} />
            {IsPartialHoliday ? 
              <div className="mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                Holiday Start Time
                <span className="text-danger">*</span>
              </label>
              <ConfigProvider
              theme= {{
                components: {
                  DatePicker: {
                    activeBorderColor:'#BDFF00',
                  }
                },
                token: {
                  colorBgContainer:'#BDFF00',
                  coloryPrimary:'#BDFF00',
                  colorTextPlaceholder:'#FFFFFF',
                  colorIcon: '#BDFF00',
                  colorTextLightSolid: '#FFFFFF',
                  colorTextDisabled: '#FFFFFF',
                  colorTextDescription: '#FFFFFF',
                }
              }}
              >
              <Space>
                <RangePicker
                status={TimePickerError === true ? "error" : "success"} 
                variant={'Filled'}
                value={partialTimes}
                format={'HH:mm'} 
                use12Hours={true}
                onClear
                onCalendarChange={onCalendarChange}
                style={{
                  border: "1px solid #FFFFFF"
                }}
                />
              </Space>
              </ConfigProvider>
              {HolidayDateError && (
                <p className="f-12 text-danger">{HolidayDateError}</p>
              )}
              </div>
            : null }
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Holiday Name<span className="text-danger">*</span>
              </label>
            </div>
            <input
              value={HolidayName}
              onChange={(e) => handleHolidayName(e)}
              type="text"
              id="Holiday"
              placeholder="Enter Name"
              className="w-100 input-style"
              autoComplete="off"
            />
            {HolidayNameError && (
              <p className="f-12 text-danger">{HolidayNameError}</p>
            )}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Holiday Date
              <span className="text-danger">*</span>
            </label>
            <ReactDatePicker
              onChange={(date) => handleHolidayDate(date)}
              id="HolidayDate"
              placeholderText="Select Date"
              className="w-100 text-input-style"
              selected={HolidayDate ? moment(HolidayDate).toDate() : null}
              minDate={new Date()}
              dateFormat="yyyy-MM-dd"
            />
            {HolidayDateError && (
              <p className="f-12 text-danger">{HolidayDateError}</p>
            )}
          </div>
          <div className="mt-5 mb-5 text-center">
            {props.Type === "Add" && (
              <button
                onClick={(e) => handleModal(e, "add")}
                className="form-button"
                disabled={IsPartialHoliday ? !(HolidayName && HolidayDate && partialTimes[0] && partialTimes[1]) : !(HolidayName && HolidayDate)}
              >
                Save
              </button>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={(e) => handleModal(e, "delete")}
                  className="form-button form-button-ghost f-14 mr-2"
                >
                  Delete
                </button>
                <button
                  disabled={IsPartialHoliday ? !(HolidayName && HolidayDate && partialTimes[0] && partialTimes[1]) : !(HolidayName && HolidayDate)}
                  onClick={(e) => handleModal(e, "update")}
                  className="form-button ml-2 f-14"
                >
                  Update
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && (
        <Modal
          Name="this holiday"
          Type={OpenModal}
          Close={(e, type) => CloseModal(e, type)}
        />
      )}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ GetHolidayReducer }) => {
  const { loading, delete_data, add_data, edit_data } = GetHolidayReducer;
  return { loading, delete_data, add_data, edit_data };
};

const mapDispatchToProps = {
  AddHoliday,
  EditHoliday,
  DeleteHoliday,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);
